let AnnotationUtil = require("../util/AnnotationUtil");
let ResizableChart = require("./ResizableChart");

class RecordingTape extends ResizableChart {
  componentDidMount() {
    super.componentDidMount();

    this.renderChart(this.props, this.state);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.renderChart(nextProps, nextState);

    return true;
  }

  renderChart(props, state) {
    let { startTs, pad, sessions, annotations } = props;
    let { width } = state;

    let rootNode = d3.select(ReactDOM.findDOMNode(this));
    let xAxisNode = rootNode.select(".rc-rec-tape-x-axis");
    let sessionsNode = rootNode.select(".rc-rec-tape-sessions");
    let annosNode = rootNode.select(".rc-rec-tape-annotations");
    let needleNode = rootNode.select(".rc-rec-tape-needle");

    let scale = d3.scaleUtc()
      .domain([startTs - pad, startTs + pad])
      .range([0, width]);

    let rects = sessionsNode.selectAll("rect").data(sessions, function (d, i) {
      return d[0];
    });

    rects = rects
      .enter()
      .append("rect")
      .merge(rects);

    rects
      .transition()
      .attr("x", function (d, i) {
        return scale(d[0]);
      });

    rects
      .attr("width", function (d, i) {
        return scale(d[1]) - scale(d[0]);
      })
      .attr("height", 15)
      .style("fill", "url(#hatch)");

    rects
      .exit()
      .remove();

    let dots = annosNode.selectAll("rect").data(annotations, function (d, i) {
      return d.id;
    });

    dots
      .exit()
      .remove();

    dots = dots
      .enter()
      .append("rect")
      .merge(dots);

    dots
      .transition()
      .attr("x", function (d, i) {
        return scale(d.startTs);
      });

    dots
      .attr("width", function (d, i) {
        return Math.max(2, scale(d.stopTs) - scale(d.startTs));
      })
      .attr("height", 6)
      .attr("fill", function (d, i) {
        return d.event.type === "recording" ? mc.ui.colors.PINK : mc.ui.colors.HOT_BLUE;
      })
      .attr("data-tooltip", function (d, i) {
        return AnnotationUtil.getDescription(d);
      });

    rootNode
      .on("mouseup", function () {
        let pt = d3.mouse(rootNode.node());
        let date = scale.invert(pt[0]);

        props.onSetStartTime(+date);
      })
      .on("mousemove", function () {
        let pt = d3.mouse(rootNode.node());

        needleNode.attr("transform", "translate(" + pt[0] + ")");
      });

    xAxisNode
      .transition()
      .call(
        d3.axisBottom()
        .scale(scale)
        .ticks(pad < (mc.math.MILLIS_PER_HOUR / 2) ? 5 : 10)
        .tickFormat(function (d) {
          return mc.format.time(d, props.timezone, "short");
        })
      );
  }

  render() {
    let { width } = this.state;

    return (
      <svg width={width} height="60" className="rc-rec-tape">
        <defs>
          <pattern id="hatch" patternUnits="userSpaceOnUse" width="4" height="4">
            <path
              d="M 0,4 l 4,-4 M -1,1 l 2,-2 M 3,5 l 2,-2"
              strokeWidth="1"
              shapeRendering="auto"
              stroke="#91c6cb"
              strokeLinecap="square"/>
         </pattern>
        </defs>
        <rect width={width} height="35" fill="white"/>
        <g className="rc-rec-tape-sessions" transform="translate(0,5)"/>
        <g className="rc-rec-tape-annotations" transform="translate(0,24)"/>
        <g className="rc-rec-tape-x-axis" transform="translate(0,35)"/>
        <line x1={width / 2} y1="0" x2={width / 2} y2="55" className="rc-rec-tape-focus"/>
        <line x1="0" y1="0" x2="0" y2="55" className="rc-rec-tape-needle"/>
      </svg>
    );
  }
}

module.exports = RecordingTape;